import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";

export function PageHead({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-[#111827]" data-testid="admin-page-title">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function KpiCard({ label, value, sub, icon: Icon, tint = "#0D5C75", testid }) {
  return (
    <div className="rounded-2xl bg-white p-5 shadow-sm border border-black/5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</div>
          <div className="mt-2 font-heading text-2xl font-extrabold text-[#111827]">{value}</div>
          {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
        </div>
        <div className="h-10 w-10 rounded-xl grid place-items-center" style={{ background: `${tint}1a`, color: tint }}>
          {Icon && <Icon size={20} />}
        </div>
      </div>
    </div>
  );
}

const STATUS_COLORS = {
  Pending: "bg-amber-100 text-amber-700", Confirmed: "bg-blue-100 text-blue-700",
  "In Progress": "bg-indigo-100 text-indigo-700", Completed: "bg-emerald-100 text-emerald-700",
  Cancelled: "bg-rose-100 text-rose-700", Refunded: "bg-rose-100 text-rose-700",
  VERIFIED: "bg-emerald-100 text-emerald-700", PENDING: "bg-amber-100 text-amber-700",
  SUSPENDED: "bg-rose-100 text-rose-700", DELETED: "bg-gray-200 text-gray-600",
  Active: "bg-emerald-100 text-emerald-700", Disabled: "bg-gray-200 text-gray-600",
};

export function StatusBadge({ status }) {
  return <Badge className={`border-0 ${STATUS_COLORS[status] || "bg-gray-100 text-gray-700"}`}>{status}</Badge>;
}

export function TableSkeleton({ rows = 6 }) {
  return (
    <div className="space-y-2" data-testid="admin-loading">
      {Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className="h-11 w-full rounded-lg" />)}
    </div>
  );
}

export function Money({ value }) {
  return <span>${Number(value || 0).toLocaleString()}</span>;
}

export function Pager({ page, total, pageSize, onPage }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="flex items-center justify-between mt-4 text-sm">
      <span className="text-muted-foreground">{total} records · page {page}/{pages}</span>
      <div className="flex gap-2">
        <button disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="admin-prev-page"
          className="px-3 py-1.5 rounded-lg border disabled:opacity-40 hover:bg-gray-50">Prev</button>
        <button disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="admin-next-page"
          className="px-3 py-1.5 rounded-lg border disabled:opacity-40 hover:bg-gray-50">Next</button>
      </div>
    </div>
  );
}
